import React from 'react';
import { connect } from 'react-redux';
import FooterCollapseView from '../FooterCollapseView/FooterCollapseView';

const DisplayRelative = ({detail, nameProduct}) => {
  return (
    <div className='proportional-charge'>
      {/* <div>חיוב יחסי</div>
      <div className='title-proportional-charge'>{detail.subTitle} </div> */}
      <div className='title-proportional-charge'>איך חושב החיוב היחסי:</div>
      <div className='proportional-charge-date'>עלות השירות לחודש <span>₪{detail.colomn1}</span></div>
      <div className='details-cost'>
        <div className='square'>
          <div className='title-square'> תעריף ליום</div>
          <div>₪{detail.colomn2}</div>
        </div>
        <span className='sign'>x</span>
        <div className='square'>
          <div className='title-square'> משך השירות</div>
          <div>{`${detail.colomn3} ימים`}</div>
        </div>
        <span className='sign'>=</span>
        <div className='square'>
          <div className='title-square'> עלות יחסית</div>
          <div>₪{(detail.colomn2 * detail.colomn3).toFixed(2)}</div>
        </div>
      </div>
      <FooterCollapseView detail={detail} nameProduct={nameProduct}></FooterCollapseView>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {

  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DisplayRelative);
